var   KEYS  = require('../../keys/Keys');
var   AXIOS = require('axios');

export {PasswordChangeWebAsync as InvokeAsync , PasswordChangeWebSync as InvokeSync}

async function PasswordChangeWebAsync(RecoverToken,Password)
{
    var PasswordChangePromise = new Promise((resolve, reject) => {
        PasswordChangeWebSync(RecoverToken,Password,(response,error) => {
            if (error) {  
                try{ 
                    return reject(error.response.data.message);
                }catch(ex){
                    return reject('Unknown error');
                }
            }
            if(response.status==='fails'){
                reject(response.error);
            }else{
                resolve(null);
            }
        });
    });

    return await PasswordChangePromise;
}

function PasswordChangeWebSync(RecoverToken,Password,Callback)
{
    AXIOS({
        headers:{
            'Content-Type': 'application/json',
            'x-api-key'   : KEYS.AWS_XKEY,
        },
        method : 'post',
        url    :'/User/PasswordChangeWeb',                
        data  : {
            RecoverToken : RecoverToken,
            Password     : Password    ,
            AppID        : KEYS.AWS_APPID              
        },                                
    })
    .then((response)=>{
        Callback(response.data,null);
    },(error) => { 
        Callback(null,error + ' ');
    });
}
